export const REF_TYPES = ["branch", "tag-lightweight", "tag-annotated", "commit-oid"];
//# sourceMappingURL=constants.js.map